// extracted by mini-css-extract-plugin
export default {"alertDialog":"CancelBooking_alertDialog__q-PF0","comboTextArea":"CancelBooking_comboTextArea__3XUHv"};